import { auth, common } from '@/api/common'
import { setting } from '@/api/services'
import { mapapi } from '@/api/localMap'
import router from '@/router'

let res = null

const actions = {
    OPEN_LOADING({commit}, payload) {
        commit('OPEN_LOADING', payload)
    },
    CLOSE_LOADING({commit}, payload) {
        commit('CLOSE_LOADING', payload)
    },
    OPEN_SYSTEM_BAR({commit}, payload) {
        commit('OPEN_SYSTEM_BAR', payload)
    },
    CLOSE_SYSTEM_BAR({commit}, payload) {
        commit('CLOSE_SYSTEM_BAR')
    },
    PAGE_STATUS({commit}, payload) {
        commit('PAGE_STATUS', payload)
    },
    // @Description 프로그램버전 조회
    async BRANCH_VERSION({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.programVersion(payload)
            console.log('BRANCH_VERSION info', res)
            if(res.data.status === 200) {
                commit('BRANCH_VERSION', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('BRANCH_VERSION error', error)
        }
    },
    // @Description 나의 전자서명 조회
    async MY_SIGNATURE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.signature(payload)
            console.log('MY_SIGNATURE info', res)
            if(res.data.status === 200) {
                commit('MY_SIGNATURE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('MY_SIGNATURE error', error)
        }
    },
    // @Description 기관변경
    async CHANGE_BRANCH({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.get.currentInfo(payload)
            console.log('CHANGE_BRANCH info', res)
            if(res.data.status === 200) {
                commit('RESET_PAGE')
                commit('OPEN_SYSTEM_BAR', {message: '상세정보를 조회완료 하였습니다. 선택하신 기관으로 이동하기 위하여 초기화 진행합니다. 잠시만 기다려주세요', color: 'success'})
                commit('SET_TOKEN', res.data.data)
                commit('SET_LOGIN_INFO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            router.push({name:'MainDashboard'}).catch(()=>{})
            setTimeout(() => {
                location.reload()
            }, 1500)
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('CHANGE_BRANCH error', error)
        }
    },
    // @Description 비밀번호 변경전 AuthCode 발급
    async RESET_PASSWORD({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.resetPwd(payload) 
            console.log('RESET_PASSWORD info', res)

            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('AUTH_DATA', {data: res.data.data, info: payload})
                commit('CHECK_USER_INFO', {data: res.data.data, info: payload})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('RESET_PASSWORD error', error)
        }
    },
    // @Description 이동하려는 페이지의 권한여부 체크
    async AUTHORITY_CONFIRM({commit}, payload) {
        try {
            return true
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('AUTHORITY_CONFIRM error', error)
        }
    } ,
    // @Description AuthCode확인 후 비밀번호 변경
    async CHANGE_PASSWORD({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.changePwd(payload)
            console.log('CHANGE_PASSWORD info', res)

            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('CHANGE_PASSWORD error', error)
        }
    },
    // @Description 발급받은 AuthCode 확인
    async CHECK_AUTH({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.confirm(payload)
            console.log('CHECK_AUTH info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                if(payload.gubun === 'registerUser'
                    ||payload.gubun === 'wlogin') {
                    commit('SET_TOKEN', res.data.data)
                    commit('SET_LOGIN_INFO', res.data.data)
                }
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('CHECK_AUTH error', error)
        }
    },
    // @Description 휴대폰번호 변경 전 사용자인증
    async CHECK_USER_INFO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.get.resetPhoneCheck(payload)
            console.log('CHECK_USER_INFO info', res)
            if(res.data.status === 200) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('CHECK_USER_INFO', {data: res.data.data, info: payload})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('CHECK_USER_INFO error', error)
        }
    },
    // @Description AuthCode확인 후 휴대폰번호 변경
    async CHANGE_MOBILE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.resetPhoneNo(payload)
            console.log('CHANGE_MOBILE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('AUTH_DATA', {data: res.data.data, info: payload})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('CHANGE_MOBILE error', error)
        }
    },
    // @Description AuthCode확인 후 회원가입
    async REGIST_USER({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.members(payload)
            console.log('REGIST_USER info', res)
            if(res.data.status === 201) {
                console.log('Authcode', res.data.data.authCode)
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('AUTH_DATA', {data: res.data.data, info: payload})
                commit('CHECK_USER_INFO', {data: res.data.data, info: payload})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
        return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('REGIST_USER error', error)
        }
    },
    // @Description 유저 로그인
    async LOGIN({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.webLogin(payload)
            console.log('LOGIN info', res)
            
            if(res.data.status === 201) {
                console.log('Authcode', res.data.data.authCode)
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('AUTH_DATA', {data: res.data.data, info: payload})
                // save temp data
                commit('CHECK_USER_INFO', {data: res.data.data, info: payload})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('LOGIN error', error)
        } 
    },
    // @Description 유저 로그아웃
    LOGOUT({commit}) {
        try {
            commit('LOGOUT')
            commit(' ', {
                message: '로그아웃되었습니다. 로그인페이지로 이동합니다.',
                color: 'success',
                inset: true
            })
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('LOGOUT error', error)
        }
    },
    // @Description 유저 QR정보 발급
    async QR_LOGIN_CODE({commit}) {
        try {
            commit('OPEN_LOADING')
            res = await auth.get.qrcode()
            console.log('QR_LOGIN_CODE info', res)
            if(res.data.status === 200) {
                commit('QR_LOGIN_CODE', res.data.data)
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('QR_LOGIN_CODE error', error)
        }
    },
    // @Description 유저 QR로그인 QR체크
    async QR_CHECK({commit}, payload) {
        try {
            res = await auth.get.qrcodeLogin(payload)
            console.log('QR_CHECK info', res)
            if(res.data.status === 200) {
                commit('SET_TOKEN', res.data.data)
                commit('SET_LOGIN_INFO', res.data.data)
            }
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('QR_CHECK error', error)
        }
    },
    // @Description 유저 기본정보 조회
    async USER_INFO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.detailInfo(payload)
            console.log('USER_INFO info', res)
            if(res.data.status === 200) {
                commit('USER_INFO', res.data.data)
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('USER_INFO error', error)
        }
    },
    // @Description 기관정보 검색(조회 공통사용)
    async SEARCH_BRANCH({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.get.itcareInstitute(payload)
            console.log('SEARCH_BRANCH info', res)
            if(res.data.status === 200 && res.data.data !== null) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('SEARCH_BRANCH', res.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('SEARCH_BRANCH error', error)
        }
    },
    // @Description 리프레시 토큰 갱신
    async AUTO_REFRESH_TOKEN({commit}, payload) {
        try {
            res = await common.get.autoRefreshToken(payload)
            console.log('AUTO_REFRESH_TOKEN info', res)
            if(res.data.status === 200) {
                commit('SET_TOKEN', res.data.data)
                commit('SET_LOGIN_INFO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('AUTO_REFRESH_TOKEN error', error)
        }
    },
    // @Description 도로명주소 검색
    async SEARCH_ADDRESS({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await mapapi.get.searchRoadName(payload)
            console.log('SEARCH_ADDRESS info', res)
            if(res.status === 200) {
                if(res.data.documents.length <= 0) {
                    commit('OPEN_SYSTEM_BAR', {message: '검색 된 주소정보가 없습니다.', color: 'info'})
                    commit('SEARCH_ADDRESS', res)
                } else {
                    commit('OPEN_SYSTEM_BAR', {message: '목록에서 주소를 선택해 주세요.', color: 'success'})
                    commit('SEARCH_ADDRESS', res)
                }
            } else {
                commit('OPEN_SYSTEM_BAR', {
                    message: '주소검색 실패, 도로명주소를 정확히 입력 후 다시 시도해주세요.',
                    color: 'error'
                })
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('SEARCH_ADDRESS error', error)
        }
    },
    // @Description 공통코드 조회
    async DETAIL_CODES({commit}, payload) {
        let compareKeyword = '104, 106, 107, 108, 291'
        try {
            if(compareKeyword.includes(String(payload.GCode))) {
                res = await auth.get.groupCodes({GCode: payload.GCode})
            } else {
                res = await common.get.groupCodes({GCode: payload.GCode, RCode: payload.RCode})
            }
            console.log('DETAIL_CODES info', res)
            commit('detailCode/DETAIL_CODES', {data: res.data.data, GCode: payload.GCode})
        } catch(error) {
            console.error('SET_DETAIL_CODES error', error)
        }
    },
    // @Description 기관등록 
    async SERVICE_CONTRACT({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.customersN(payload)
            console.log('SERVICE_CONTRACT info', res)
            if(res.data.status !== 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('SERVICE_CONTRACT error', error)
        }
    },
    // @Description 기관정보 조회
    async BRANCH_INFO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.get.customer(payload)
            console.log('BRANCH_INFO info', res)
            if(res.data.status === 200) {
                commit('BRANCH_INFO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('BRANCH_INFO error', error)
        }
    },
    // @Desctiprion 기관정보 변경 
    async UPDATE_BRANCH_INFO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            payload.ssisLoginPwd = payload.ssisLoginPwd?btoa(payload.ssisLoginPwd.replace(/=/g,'')):null
            res = await setting.post.customer(payload)
            console.log('UPDATE_BRANCH_INFO info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('BRANCH_INFO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('UPDATE_BRANCH_INFO error', error)
        }
    },
    // @Description 기관로고 등록
    async UPLOAD_LOGO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.post.logo(payload)
            console.log('UPLOAD_LOGO info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('UPLOAD_LOGO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('UPLOAD_LOGO error', error)
        }
    },
    // @Description 기관로고 삭제
    async DELETE_LOGO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.delete.logo(payload)
            console.log('DELETE_LOGO info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('DELETE_LOGO')
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('DELETE_LOGO error', error)
        }
    },
    // @Description 기관직인 조회
    async OFFICE_SEAL({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.get.officeSeal(payload)
            console.log('OFFICE_SEAL info', res)
            if(res.data.status === 200) {
                commit('OFFICE_SEAL', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
        } catch(error) { 
            commit('CLOSE_LOADING')
            console.error('OFFICE_SEAL error', error)
        }
    },
    // @Description 기관직인 등록
    async UPLOAD_OFFICE_SEAL({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.post.officeSeal(payload)
            console.log('UPLOAD_OFFICE_SEAL info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('OFFICE_SEAL', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('UPLOAD_OFFICE_SEAL error', error)
        }
    },
    // @Description 기관직인 삭제
    async DELETE_OFFICE_SEAL({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await setting.delete.officeSeal(payload)
            console.log('DELETE_OFFICE_SEAL info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('DELETE_OFFICE_SEAL')
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('DELETE_OFFICE_SEAL error', error)
        }
    },
    // @Description 파일 다운로드
    async DOWNLOAD_FILE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.downloadFile(payload)
            console.log('DOWNLOAD_FILE info', res)
            if(res.status !== 200) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('DOWNLOAD_FILE error', error)
        }
    },
    // @Description 나의서명 등록
    async REGIST_MY_SIGNATURE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.signature(payload)
            console.log('REGIST_MY_SIGNATURE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('REGIST_MY_SIGNATURE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('REGIST_MY_SIGNATURE error', error)
        }
    },
    // @Description 나의서명 삭제
    async DELETE_MY_SIGNATURE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.delete.signature(payload)
            console.log('DELETE_MY_SIGNATURE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('DELETE_MY_SIGNATURE')
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('DELETE_MY_SIGNATURE error', error)
        }
    },
     // @Description 수급자 또는 보호자 서명 조회
     async COMMON_SIGNATURE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.commonSignature(payload)
            console.log('COMMON_SIGNATURE info', res)
            if(res.data.status === 200) {
                commit('PERSON_SIGNATURE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('COMMON_SIGNATURE error', error)
        }
    },
    // @Description 수급자 또는 보호자 서명 등록
    async REGIST_COMMON_SIGNATURE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.commonSignature(payload)
            console.log('COMMON_SIGNATURE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('PERSON_SIGNATURE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('COMMON_SIGNATURE error', error)
        }
    },
    // @Description 나의 프로필이미지 등록
    async REGIST_MY_IMAGE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.fileUpload(payload)
            console.log('REGIST_MY_IMAGE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('REGIST_MY_IMAGE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('REGIST_MY_IMAGE error', error)
        }
    },
    // @Description 나의 프로필이미지 삭제
    async DELETE_MY_IMAGE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.delete.fileUpload(payload)
            console.log('DELETE_MY_IMAGE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('DELETE_MY_IMAGE')
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('DELETE_MY_IMAGE error', error)
        }
    },
    // @Description 나의 근로계약 내용 조회
    async MY_EMPLOYMENT_CONTRACTS({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.get.contract(payload)
            console.log('MY_EMPLOYMENT_CONTRACTS info', res)
            if(res.data.status === 200) {
                commit('MY_EMPLOYMENT_CONTRACTS', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('MY_EMPLOYMENT_CONTRACTS error', error)
        }
    },
    // // @Description 나의 급여정보 조회
    // async MY_PAYSLIPS({commit}, payload) {
    //     try {
    //         commit('OPEN_LOADING')
    //         res = await auth.get.payslip(payload)
    //         console.log('MY_PAYSLIPS info', res)
    //         if(res.data.status === 200) {
    //             commit('MY_PAYSLIPS', res.data.data)
    //         } else {
    //             commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
    //         }
    //         commit('CLOSE_LOADING')
    //         return res.data
    //     } catch(error) {
    //         commit('CLOSE_LOADING')
    //         console.error('MY_PAYSLIPS error', error)
    //     }
    // },
    // @Description 인증서 다운로드
    async DOWNLOAD_CERT({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.downloadFile(payload)
            console.log('DOWNLOAD_CERT info', res)
            if(res.status !== 200) {
                commit('OPEN_SYSTEM_BAR', {message: res.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('DOWNLOAD_CERT error', error)
        }
    },
    // @Description 인증서 상태가져오기
    async GET_CONNECT_CERT({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.certificate(payload)
            console.log('GET_CONNECT_CERT info', res)
            if(res.data.status === 200) {
                commit('GET_CONNECT_CERT', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch(error) {
            commit('CLOSE_LOADING')
            console.error('GET_CONNECT_CERT error', error)
        }
    },
    // @Description 서명요청 발송
    async PUSH_SIGN_NOTI({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.pushSignNoti(payload)
            console.log('PUSH_SIGN_NOTI info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('PUSH_SIGN_NOTI error', error)
        }
    },
    // @Description 보호자 서명리스트 조회
    async GUARDIAN_SIGN_LIST({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.get.commonSignList(payload)
            console.log('GUARDIAN_SIGN_LIST info', res)
            if(res.data.status === 200) {
                commit('GUARDIAN_SIGN_LIST', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('GUARDIAN_SIGN_LIST error', error)
        }
    },
    // @Description 서명정보 상세
    async GUARDIAN_SIGN({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.guardianSign(payload)
            console.log('GUARDIAN_SIGN info', res)
            if(res.data.status === 200) {
                // commit('GUARDIAN_SIGN', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('GUARDIAN_SIGN error', error)
        }
    },
    // @Description 토큰없이 파일 조회
    async READ_FILE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.readFile(payload)
            console.log('READ_FILE info', res)
            if(res.status === 200) {
                // commit('GUARDIAN_SIGN', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('READ_FILE error', error)
        }
    },
    // @Description 서명정보 저장(보호자, 수급자)
    async REGIST_COMMON_SIGN({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.post.commonSign(payload)
            console.log('REGIST_COMMON_SIGN info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('REGIST_COMMON_SIGN error', error)
        }
    },
    // @Description SMS정보 조회
    async SMS_PRE_INFO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.smsPreInfo(payload)
            console.log('SMS_PRE_INFO info', res)
            if(res.status === 200) {
                commit('SMS_PRE_INFO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('SMS_PRE_INFO error', error)
        }
    },
    // @Description SMS발송 사용자 리스트 조회
    async SMS_USER_LIST({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.smsUserList(payload)
            console.log('SMS_USER_LIST info', res)
            if(res.status === 200) {
                commit('SMS_USER_LIST', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('SMS_USER_LIST error', error)
        }
    },
    // @Description SMS발송
    async SEND_SMS({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.sendSms(payload)
            console.log('SEND_SMS info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
                commit('SEND_SMS', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('SEND_SMS error', error)
        }
    },
    // @Description SMS충전정보 조회
    async SMS_PAYMENT_INFO({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.smsPaymentInfo(payload)
            console.log('SMS_PAYMENT_INFO info', res)
            if(res.data.status === 200) {
                commit('SMS_PAYMENT_INFO', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('SMS_PAYMENT_INFO error', error)
        }
    },
    // @Description 결제 전 호출
    async PRE_SMS_PAYMENT({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.paymentInfo(payload)
            console.log('PRE_SMS_PAYMENT info', res)
            if(res.data.status === 201) {
                
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('PRE_SMS_PAYMENT error', error)
        }
    },
    // @Description 결제취소
    async PAYMENT_CANCEL({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.paymentCancel(payload)
            console.log('PAYMENT_CANCEL info', res)
            if(res.data.status === 201) {
                // commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('PAYMENT_CANCEL error', error)
        }
    },
    // @Description 결제완료
    async PAYMENT({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.payment(payload)
            console.log('PAYMENT info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('PAYMENT error', error)
        }
    },
    // @Description 보호자서명 기본정보 조회
    async GUARDIAN_SIGN_DEFAULT({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await auth.get.signInfo(payload)
            console.log('GUARDIAN_SIGN_DEFAULT info', res)
            if(res.data.status === 200) {
                commit('GUARDIAN_SIGN_DEFAULT', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('GUARDIAN_SIGN_DEFAULT error', error)
        }
    },
    // @Description 직원회의록 작성 후 직원 푸시
    async PUSH_MEETING({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.pushMeeting(payload)
            console.log('PUSH_MEETING info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('PUSH_MEETING error', error)
        }
    },
    // @Description 메인 대시보드
    async DASHBOARD({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.dash(payload)
            console.log('DASHBOARD info', res)
            if(res.data.status === 200) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success', inset: false})
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('DASHBOARD error', error)
        }
    },
    // @Description SMS템플릿 조회
    async SMS_TEMPLETE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.smsTemplete(payload)
            console.log('SMS_TEMPLETE info', res)
            if(res.data.status === 200) {
                commit('SMS_TEMPLETE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error', inset: false})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('SMS_TEMPLETE error', error)
        }
    },
    // @Description SMS템플릿 저장
    async REGIST_SMS_TEMPLETE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.smsTemplete(payload)
            console.log('REGIST_SMS_TEMPLETE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('REGIST_SMS_TEMPLETE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('REGIST_SMS_TEMPLETE error', error)
        }
    }, 
    // @Description SMS템플릿 즐겨찾기
    async SMS_TEMPLETE_BOOKMARK({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.templeteBookmark(payload)
            console.log('SMS_TEMPLETE_BOOKMARK info', res)
            if(res.data.status === 201) {
                commit('SMS_TEMPLETE_BOOKMARK', {
                    index: payload.index,
                    yn: payload.bookmarkYn
                })
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('SMS_TEMPLETE_BOOKMARK error', error)
        }
    }, 
    // @Description SMS템플릿 삭제하기
    async DELETE_SMS_TEMPLETE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.delete.smsTemplete(payload)
            console.log('DELETE_SMS_TEMPLETE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'success'})
                commit('DELETE_SMS_TEMPLETE', payload.index)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('DELETE_SMS_TEMPLETE error', error)
        }
    }, 
    // @Description DEFAULT_SMS_TEMPLETE
    async DEFAULT_SMS_TEMPLETE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.post.smsTemplete(payload)
            console.log('DEFAULT_SMS_TEMPLETE info', res)
            if(res.data.status === 201) {
                commit('OPEN_SYSTEM_BAR', {message: '기본템플릿으로 저장되었습니다. 카테고리별로 기본템플릿을 한개씩 지정할 수 있습니다.', color: 'success'})
                commit('DEFAULT_SMS_TEMPLETE', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('DEFAULT_SMS_TEMPLETE error', error)
        }
    }, 
    // @Description 국가공휴일 조회
    async COMMON_HOLIDAY({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.commonHoliday(payload)
            console.log('COMMON_HOLIDAY info', res)
            if(res.data.status === 200) {
                commit('COMMON_HOLIDAY', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('COMMON_HOLIDAY error', error)
        }
    }, 
    // @Description 오늘기준 영업일 40일 조회
    async BUSINESS_DAY({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.businessDay(payload)
            console.log('BUSINESS_DAY info', res)
            if(res.data.status === 200) {
                commit('BUSINESS_DAY', res.data.data)
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('BUSINESS_DAY error', error)
        }
    }, 
    // @Description 맘스비 비용조회(링크)
    async MOMSBY_CHARGE({commit}, payload) {
        try {
            commit('OPEN_LOADING')
            res = await common.get.prodServiceFee(payload)
            console.log('MOMSBY_CHARGE info', res)
            if(res.data.status === 200) {
                
            } else {
                commit('OPEN_SYSTEM_BAR', {message: res.data.message, color: 'error'})
            }
            commit('CLOSE_LOADING')
            return res.data
        } catch (error) {
            commit('CLOSE_LOADING')
            console.error('MOMSBY_CHARGE error', error)
        }
    }
}

export default actions;



// WEBPACK FOOTER //
// ./src/store/default/actions.js